// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"be3141c8","826":"f8196929"}[chunkId] + ".chunk.js";
};